export enum Side {
    Left,
    Right,
}
